/*=========================================================================================
  File Name: moduleRolesActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	// Consulta los roles
	getRoles({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/role")
				.then((res) => {
					commit("SET_ROLES", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Consulta los permisos
	getPermissions({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/permission")
				.then((res) => {
					commit("SET_PERMISSIONS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Consula las relaciones Rol-permiso
	getRolePermission({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/rolepermission")
				.then((res) => {
					commit("SET_ROLE_PERMISSIONS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Crea un rol
	addRole({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/role", object)
				.then((response) => {
					//this.dispatch('moduleRoles/getRoles')
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Elimina el Rol
	removeRole({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/role/${itemId}`)
				.then((response) => {
					commit("REMOVE_ROLE", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Actualiza el Rol
	updateRole({commit}, {id: idR, ...restData}) {
		let id = idR;
		return new Promise((resolve, reject) => {
			Api.put(`/role/${id}`, JSON.stringify(restData))
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
